import React from 'react';
import { Outlet } from 'react-router';
import MenuLeft from '../components/menu/MenuLeft';
import MenuTop from '../components/menu/MenuTop';
import { LayoutFull, LayoutHorizontal, LayoutVerticalMain } from '@ydistri/ds';
import { StableParamsProvider, StableSearchProvider } from './useStableParams';
import ModalDisplay from '../screens/Modals/ModalDisplay';
import ApplicationStatusController from './ApplicationStatusController';
import YbotDock from '../components/global/Ybot/YbotDock';

const PageLayout: React.FC = () => {
  return (
    <LayoutFull data-type="LayoutFull">
      <StableParamsProvider>
        <StableSearchProvider>
          <LayoutHorizontal>
            <ApplicationStatusController />
            <MenuLeft />
            {/* The dock floats over the bottom of this column; it changes no layout of its own. */}
            <LayoutVerticalMain data-type="LayoutVertical">
              <MenuTop />
              <Outlet />
              <ModalDisplay />
              <YbotDock />
            </LayoutVerticalMain>
          </LayoutHorizontal>
        </StableSearchProvider>
      </StableParamsProvider>
    </LayoutFull>
  );
};

export default PageLayout;
